// src/services/flightService.ts
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/travel/flights`;

export const getFlights = () => axios.get(API_URL);
export const createFlight = (flight: any) => axios.post(API_URL, flight);
export const updateFlight = (id: string, flight: any) =>
  axios.put(`${API_URL}/${id}`, flight);
export const deleteFlight = (id: string) => axios.delete(`${API_URL}/${id}`);
